import WebComponentPortal, { type PortalProps } from './WebComponentPortal.js';

export type WrapperProps = {
    styleLink?: string;
} & PortalProps;

/**
 * This component will wrap you children in a web component through a react portal.
 * The styling provided will be inside of a shadow dom which makes it only affect the
 * content inside (the children).
 *
 * @prop 'containerElement' - the div you want to be the root of the portal.
 * @prop 'styleLink' - url to the css-file you want to be scoped (most likely warp-styling).
 * @prop 'children' - the content you want wrapped in the web component.
 * @returns A reactnode with children and styling wrapped in a shadow dom.
 */
const WebComponentWrapper = ({ containerElement, styleLink, children }: WrapperProps) => (
    // @ts-ignore
    <WebComponentPortal containerElement={containerElement}>
        {styleLink && <link href={styleLink} media="all" type="text/css" rel="stylesheet" />}
        {children}
    </WebComponentPortal>
);

export default WebComponentWrapper;
